import { css } from "../../../styled-system/css";

export const styles = {
  categoryCard: () =>
    css({
      width: "100%",
      paddingY: "baseUnit.mobile5",
      paddingX: "baseUnit.mobile2",
      textAlign: "center",
      display: "block",
      textDecoration: "none",
    }),
  categoryIconWrapper: () =>
    css({
      height: "128px",
      display: "flex",
      justifyContent: "center",
      marginBottom: "baseUnit.mobile3",
    }),
  categoryIconPlaceholder: () =>
    css({
      width: "128px",
      height: "128px",
      marginBottom: "baseUnit.mobile3",
      backgroundColor: "transparent",
    }),
  categoryTitle: () =>
    css({
      marginBottom: "baseUnit.mobile3",
      color: "headlineGrey",
      fontSize: "heading.H2.mobile",
      lineHeight: "heading.H2.mobile",
      fontWeight: "bold",
      desktop: {
        fontSize: "heading.H2.desktop",
        lineHeight: "heading.H2.desktop",
      },
    }),
  categoryExcerpt: () =>
    css({
      marginBottom: "baseUnit.mobile3",
      fontWeight: "normal",
      fontSize: "body.mouse",
    }),
  categoryCta: () =>
    css({
      width: "100%",
      fontWeight: "bold",
      color: "linkBlue",
      letterSpacing: "normal",
      _hover: {
        textDecoration: "underline",
      },
    }),
};
